// extracted by mini-css-extract-plugin
module.exports = {"person-card":"style_person-card__8zK3c"};